import { useActions } from 'shared/hooks';
import { sendContactInfo } from 'api/surveys';
import { postConsultation, postCustomBlock } from 'store/survey/actions';
import { SendContactData } from '../../../../api/surveys/types';
import * as React from 'react';

export const useSurveyActions = () =>
  useActions({
    postConsultation,
    postCustomBlock,
  });

export const useHandleSubmit = () => {
  return async (
    data: SendContactData,
    showError: React.Dispatch<React.SetStateAction<boolean>>,
    finishedPosting: React.Dispatch<React.SetStateAction<boolean>>,
    onPreferredEmailSyncFailed?: () => void,
  ) => {
    try {
      const result = await sendContactInfo(data);
      if (result.preferred_email_sync_failed) {
        onPreferredEmailSyncFailed?.();
        return;
      }
      localStorage.setItem('contact_email', data.email);
      finishedPosting(true);
    } catch (e) {
      showError(true);
    }
  };
};

export const useFinalizeConsultation = () => {
  const { postConsultation: finalizeConsultation } = useSurveyActions();
  return async (id: string) => {
    try {
      await finalizeConsultation({ respondent_id: id });
    } catch (e) {
      console.log(e);
    }
  };
};

export const useFinalizeCustomBlock = () => {
  const { postCustomBlock: finalizeCustomBlock } = useSurveyActions();
  return async (url: string, did_opt_in: boolean) => {
    try {
      await finalizeCustomBlock({ survey_request_url: url, did_opt_in });
    } catch (e) {
      console.log(e);
    }
  };
};
